import { ImgHTMLAttributes } from 'react';
import { Image } from './Image';

export const Avatar = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  return <Image {...props} defaultSrc='/Images/default-avatar.png' />;
};
